module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['collection', _vm.model]
  }, [(_vm.loading == false) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.structure), function(column) {
    return _c('th', {
      directives: [{
        name: "can-dom",
        rawName: "v-can-dom",
        value: (column.credentials),
        expression: "column.credentials"
      }],
      key: column.name,
      staticClass: "heading",
      class: column.class
    }, [(column.icon) ? _c('span', {
      staticClass: "heading--title icon",
      attrs: {
        "title": _vm.$t('models.' + _vm.model + '.' + column.name)
      }
    }, [_vm._v("\n            " + _vm._s(column.icon) + "\n          ")]) : (column.alias) ? _c('span', {
      staticClass: "heading--title"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("models." + _vm.model + "." + column.alias)) + "\n          ")]) : ((column.name == 'classification')) ? _c('span', {
      staticClass: "heading--title"
    }) : _c('span', {
      staticClass: "heading--title"
    }, [_vm._v("\n            " + _vm._s(_vm.$t("models." + _vm.model + "." + column.name)) + "\n          ")]), _vm._v(" "), (column.sortable && _vm.sortedData.length > 0) ? _c('div', {
      class: {
        'heading--sorting': true, 'is-active': _vm.sortKey == column.name
      }
    }, [(_vm.reverse && _vm.sortKey == column.name) ? _c('a', {
      staticClass: "icon yule-icon-chevron-down icon-tiny",
      on: {
        "click": function($event) {
          return _vm.sortBy(column.name)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.reverse && _vm.sortKey == column.name) ? _c('a', {
      staticClass: "icon yule-icon-chevron-top icon-tiny",
      on: {
        "click": function($event) {
          return _vm.sortBy(column.name)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.sortKey != column.name) ? _c('a', {
      staticClass: "icon yule-icon-chevron-right icon-tiny",
      on: {
        "click": function($event) {
          return _vm.sortBy(column.name)
        }
      }
    }) : _vm._e()]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.collectionPresent()) ? _c('tbody', _vm._l((_vm.sortedData), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "collection--row"
    }, _vm._l((_vm.structure), function(column) {
      return _c('collection-value', _vm._b({
        directives: [{
          name: "can-dom",
          rawName: "v-can-dom",
          value: (column.credentials),
          expression: "column.credentials"
        }],
        key: column.name,
        attrs: {
          "params": _vm.params,
          "model": _vm.model,
          "column": column,
          "item": item
        },
        on: {
          "itemDelete": _vm.itemDelete
        }
      }, 'collection-value', {
        toString: function () { return item.id; }
      }, false))
    }), 1)
  }), 0) : (_vm.loadingCollection()) ? _c('div', [_c('loading')], 1) : (_vm.noResultsHandler()) ? _c('tbody', [_c('tr', {
    staticClass: "txtcenter"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.structure.length
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.no_results')))])])]) : _c('tbody', [_c('tr', {
    staticClass: "txtcenter"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.structure.length
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.empty_collection')))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bdafa83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/Collection.vue
// module id = 1953
// module chunks = 0